[
  {
    "draftJersey": 1,
    "role": "DF",
    "name": "Anna Burgaya",
    "foot": "right",
    "height": 169,
    "birthdate": "29/06/1982",
    "country": "España",
    "macros": {
      "physical": 72,
      "duels": 82,
      "shooting": 78,
      "defence": 86,
      "passing": 80,
      "skills": 76,
      "average": 80
    },
    "matchYtVideoId": "Jn5TULMJhgY",
    "profileYtVideoId": "u1tJUbkse_I",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/172865653.png"
  },
  {
    "draftJersey": 2,
    "role": "DF",
    "name": "Ariana Martos",
    "foot": "right",
    "height": 160,
    "birthdate": "25/02/1994",
    "country": "España",
    "macros": {
      "physical": 69,
      "duels": 73,
      "shooting": 54,
      "defence": 70,
      "passing": 66,
      "skills": 75,
      "average": 68
    },
    "matchYtVideoId": "Jn5TULMJhgY",
    "profileYtVideoId": "kuTT9EuPJ2M",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/239076885.png"
  },
  {
    "draftJersey": 4,
    "role": "DF",
    "name": "Ekaterina Sánchez",
    "foot": "right",
    "height": 163,
    "birthdate": "13/07/2001",
    "country": "España",
    "macros": {
      "physical": 73,
      "duels": 82,
      "shooting": 77,
      "defence": 85,
      "passing": 78,
      "skills": 74,
      "average": 79
    },
    "matchYtVideoId": "z7Osz1N5VnI",
    "profileYtVideoId": "bk0_bhI864o",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/449092954.png"
  },
  {
    "draftJersey": 21,
    "role": "MC",
    "name": "Alba Montes",
    "foot": "left",
    "height": 162,
    "birthdate": "07/09/2004",
    "country": "España",
    "macros": {
      "physical": 74,
      "duels": 65,
      "shooting": 60,
      "defence": 62,
      "passing": 77,
      "skills": 61,
      "average": 66
    },
    "matchYtVideoId": "z7Osz1N5VnI",
    "profileYtVideoId": "eC-8UiETq-M",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/425239538.png"
  },
  {
    "draftJersey": 23,
    "role": "MC",
    "name": "Ana Álvarez",
    "foot": "right",
    "height": 166,
    "birthdate": "02/04/2004",
    "country": "España",
    "macros": {
      "physical": 67,
      "duels": 86,
      "shooting": 86,
      "defence": 84,
      "passing": 85,
      "skills": 86,
      "average": 83
    },
    "matchYtVideoId": "z7Osz1N5VnI",
    "profileYtVideoId": "20hCLBied3w",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/144668956.png"
  },
  {
    "draftJersey": 27,
    "role": "MC",
    "name": "Ariadna Losada",
    "foot": "left",
    "height": 167,
    "birthdate": "07/04/2004",
    "country": "España",
    "macros": {
      "physical": 68,
      "duels": 76,
      "shooting": 72,
      "defence": 70,
      "passing": 74,
      "skills": 71,
      "average": 72
    },
    "matchYtVideoId": "knY_qbwbuz4",
    "profileYtVideoId": "Ux1JuigSTdM",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/227557950.png"
  },
  {
    "draftJersey": 40,
    "role": "MC",
    "name": "María Cervelló",
    "foot": "right",
    "height": 176,
    "birthdate": "01/07/2001",
    "country": "España",
    "macros": {
      "physical": 69,
      "duels": 76,
      "shooting": 78,
      "defence": 77,
      "passing": 70,
      "skills": 74,
      "average": 74
    },
    "matchYtVideoId": "61CbJ-9wS1Q",
    "profileYtVideoId": "NfnAqMTZzNo",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/423501504.png"
  },
  {
    "draftJersey": 52,
    "role": "DF",
    "name": "Jessica Navarro",
    "foot": "right",
    "height": 165,
    "birthdate": "04/09/2003",
    "country": "España",
    "macros": {
      "physical": 81,
      "duels": 71,
      "shooting": 70,
      "defence": 70,
      "passing": 73,
      "skills": 68,
      "average": 72
    },
    "matchYtVideoId": "Jn5TULMJhgY",
    "profileYtVideoId": "NpGvxNKwZb4",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/975147152.png"
  },
  {
    "draftJersey": 54,
    "role": "DF",
    "name": "Laia Cámara",
    "foot": "right",
    "height": 170,
    "birthdate": "29/11/2005",
    "country": "España",
    "macros": {
      "physical": 70,
      "duels": 71,
      "shooting": 75,
      "defence": 71,
      "passing": 60,
      "skills": 72,
      "average": 70
    },
    "matchYtVideoId": "IY9qBkPSrpA",
    "profileYtVideoId": "lB7Me50UH2g",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/315195448.png"
  },
  {
    "draftJersey": 55,
    "role": "DF",
    "name": "Mar López  ",
    "foot": "left",
    "height": 165,
    "birthdate": "17/07/2004",
    "country": "España",
    "macros": {
      "physical": 72,
      "duels": 69,
      "shooting": 55,
      "defence": 76,
      "passing": 67,
      "skills": 68,
      "average": 69
    },
    "matchYtVideoId": "knY_qbwbuz4",
    "profileYtVideoId": "pshItJGIopw",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/360100885.png"
  },
  {
    "draftJersey": 58,
    "role": "DL",
    "name": "Carla Ventura",
    "foot": "right",
    "height": 153,
    "birthdate": "03/06/1990",
    "country": "España",
    "macros": {
      "physical": 76,
      "duels": 78,
      "shooting": 76,
      "defence": 77,
      "passing": 78,
      "skills": 79,
      "average": 77
    },
    "matchYtVideoId": "Jn5TULMJhgY",
    "profileYtVideoId": "PDVlah4rE8M",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/346944207.png"
  },
  {
    "draftJersey": 59,
    "role": "DL",
    "name": "Carlota Ferrer",
    "foot": "right",
    "height": 171,
    "birthdate": "24/04/1997",
    "country": "España",
    "macros": {
      "physical": 72,
      "duels": 79,
      "shooting": 75,
      "defence": 78,
      "passing": 78,
      "skills": 78,
      "average": 76
    },
    "matchYtVideoId": "Jn5TULMJhgY",
    "profileYtVideoId": "q0xiSMJMsAk",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/145129225.png"
  },
  {
    "draftJersey": 60,
    "role": "DL",
    "name": "Carmen Gálvez",
    "foot": "right",
    "height": 158,
    "birthdate": "10/11/2004",
    "country": "España",
    "macros": {
      "physical": 82,
      "duels": 80,
      "shooting": 80,
      "defence": 77,
      "passing": 84,
      "skills": 80,
      "average": 80
    },
    "matchYtVideoId": "z7Osz1N5VnI",
    "profileYtVideoId": "U1of1cy5IDc",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/945117062.png"
  },
  {
    "draftJersey": 87,
    "role": "MC",
    "name": "Núria Aguilar",
    "foot": "right",
    "height": 163,
    "birthdate": "22/08/1997",
    "country": "España",
    "macros": {
      "physical": 73,
      "duels": 64,
      "shooting": 61,
      "defence": 71,
      "passing": 58,
      "skills": 74,
      "average": 66
    },
    "matchYtVideoId": "x-2FfPAk0UI",
    "profileYtVideoId": "5sQmvoa40eQ",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/32471980.png"
  },
  {
    "draftJersey": 65,
    "role": "DL",
    "name": "Leiriane Aguiar",
    "foot": "right",
    "height": 164,
    "birthdate": "13/03/1996",
    "country": "España",
    "macros": {
      "physical": 77,
      "duels": 85,
      "shooting": 86,
      "defence": 79,
      "passing": 86,
      "skills": 86,
      "average": 84
    },
    "matchYtVideoId": "knY_qbwbuz4",
    "profileYtVideoId": "15CZrNN6TFs",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/947398318.png"
  },
  {
    "draftJersey": 68,
    "role": "MC",
    "name": "Cinta Vilarroya",
    "foot": "left",
    "height": 167,
    "birthdate": "03/06/2002",
    "country": "España",
    "macros": {
      "physical": 65,
      "duels": 77,
      "shooting": 74,
      "defence": 73,
      "passing": 75,
      "skills": 76,
      "average": 74
    },
    "matchYtVideoId": "z7Osz1N5VnI",
    "profileYtVideoId": "VTOYvocismw",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/754735665.png"
  },
  {
    "draftJersey": 73,
    "role": "MC",
    "name": "Esther Rodríguez",
    "foot": "right",
    "height": 160,
    "birthdate": "20/02/1995",
    "country": "España",
    "macros": {
      "physical": 78,
      "duels": 63,
      "shooting": 78,
      "defence": 67,
      "passing": 63,
      "skills": 70,
      "average": 70
    },
    "matchYtVideoId": "IY9qBkPSrpA",
    "profileYtVideoId": "ivgCOJc-Kgg",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/510386984.png"
  },
  {
    "draftJersey": 77,
    "role": "MC",
    "name": "Marta Enrich",
    "foot": "right",
    "height": 161,
    "birthdate": "11/09/1991",
    "country": "España",
    "macros": {
      "physical": 79,
      "duels": 80,
      "shooting": 74,
      "defence": 83,
      "passing": 77,
      "skills": 75,
      "average": 78
    },
    "matchYtVideoId": "knY_qbwbuz4",
    "profileYtVideoId": "zvRUKK39DdI",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/55261378.png"
  },
  {
    "draftJersey": 79,
    "role": "DF",
    "name": "Paula Pérez",
    "foot": "right",
    "height": 171,
    "birthdate": "08/12/2006",
    "country": "España",
    "macros": {
      "physical": 69,
      "duels": 70,
      "shooting": 59,
      "defence": 73,
      "passing": 67,
      "skills": 78,
      "average": 69
    },
    "matchYtVideoId": "x-2FfPAk0UI",
    "profileYtVideoId": "uGhpEc3uRJk",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/236126963.png"
  },
  {
    "draftJersey": 350,
    "role": "DL",
    "name": "Sheyla Andrino",
    "foot": "right",
    "height": 154,
    "birthdate": "13/06/1999",
    "country": "España",
    "macros": {
      "physical": 79,
      "duels": 80,
      "shooting": 86,
      "defence": 82,
      "passing": 70,
      "skills": 87,
      "average": 82
    },
    "matchYtVideoId": "8NTn2hEkJkk",
    "profileYtVideoId": "f_GGNmxXw2w",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/446444569.png"
  },
  {
    "draftJersey": 111,
    "role": "MC",
    "name": "Mireia Lluch",
    "foot": "left",
    "height": 168,
    "birthdate": "28/01/1993",
    "country": "España",
    "macros": {
      "physical": 70,
      "duels": 78,
      "shooting": 83,
      "defence": 76,
      "passing": 84,
      "skills": 84,
      "average": 80
    },
    "matchYtVideoId": "x-2FfPAk0UI",
    "profileYtVideoId": "tEA2T1JGQXo",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/108782382.png"
  },
  {
    "draftJersey": 114,
    "role": "DL",
    "name": "Yesenia Ortiz",
    "foot": "right",
    "height": 157,
    "birthdate": "30/01/2005",
    "country": "España",
    "macros": {
      "physical": 71,
      "duels": 84,
      "shooting": 87,
      "defence": 75,
      "passing": 83,
      "skills": 80,
      "average": 81
    },
    "matchYtVideoId": "x-2FfPAk0UI",
    "profileYtVideoId": "Yvn8PQ_PMIM",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/200960691.png"
  },
  {
    "draftJersey": 115,
    "role": "DL",
    "name": "Nora Rosales",
    "foot": "left",
    "height": 161,
    "birthdate": "16/05/1999",
    "country": "España",
    "macros": {
      "physical": 73,
      "duels": 64,
      "shooting": 63,
      "defence": 68,
      "passing": 69,
      "skills": 65,
      "average": 66
    },
    "matchYtVideoId": "8NTn2hEkJkk",
    "profileYtVideoId": "OoxtjxC8gBs",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/560123420.png"
  },
  {
    "draftJersey": 118,
    "role": "DF",
    "name": "Rachele Sartirani",
    "foot": "left",
    "height": 163,
    "birthdate": "20/11/1998",
    "country": "España",
    "macros": {
      "physical": 66,
      "duels": 74,
      "shooting": 70,
      "defence": 78,
      "passing": 78,
      "skills": 71,
      "average": 73
    },
    "matchYtVideoId": "8NTn2hEkJkk",
    "profileYtVideoId": "ba_D_CofyMU",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/36869661.png"
  },
  {
    "draftJersey": 121,
    "role": "DF",
    "name": "Dayanna Aquino",
    "foot": "left",
    "height": 169,
    "birthdate": "01/02/1995",
    "country": "España",
    "macros": {
      "physical": 74,
      "duels": 72,
      "shooting": 70,
      "defence": 71,
      "passing": 76,
      "skills": 74,
      "average": 73
    },
    "matchYtVideoId": "ukZsKxGejbI",
    "profileYtVideoId": "Z6I8bS2exNQ",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/280016746.png"
  },
  {
    "draftJersey": 136,
    "role": "MC",
    "name": "Lídia Rodríguez",
    "foot": "right",
    "height": 165,
    "birthdate": "19/09/1997",
    "country": "España",
    "macros": {
      "physical": 77,
      "duels": 60,
      "shooting": 59,
      "defence": 69,
      "passing": 79,
      "skills": 64,
      "average": 68
    },
    "matchYtVideoId": "ukZsKxGejbI",
    "profileYtVideoId": "Bl8ZriPk7FI",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/165469479.png"
  },
  {
    "draftJersey": 180,
    "role": "MC",
    "name": "Leticia Viñole",
    "foot": "right",
    "height": 155,
    "birthdate": "31/01/1989",
    "country": "España",
    "macros": {
      "physical": 71,
      "duels": 60,
      "shooting": 62,
      "defence": 72,
      "passing": 65,
      "skills": 71,
      "average": 66
    },
    "matchYtVideoId": "ukZsKxGejbI",
    "profileYtVideoId": "xya23a_osyU",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/478047806.png"
  }
]